<template>

  <div class="pt-4 bg-primary main-wrapper">
    <div class="bg-primary">

      <div class="container-sm p-0 bg-white shadow position-relative">
        <div class="text-end position-absolute top-0 w-100 start-0">
<!--          <router-link to="/order-history" class="btn btn-warning rounded-0">-->
<!--          Historie objednávek-->
<!--          </router-link>-->
<!--                      <router-link to="" @click="appStore.logout" class="btn btn-danger rounded-0">Odhlásit</router-link>-->

        </div>
        <div class="p-2">
          <header class="bg-light-green text-center py-3 px-2 mb-3 rounded-top">
            <router-link to="/order" class="text-decoration-none">
              <img src="/src/assets/images/logo-png.png" alt="Girafruit logo" style="max-height: 48px;">
              <div class="text-dark fw-semibold mt-1">objednavky.girafruit.cz</div>
            </router-link>
          </header>
          <nav class="navbar navbar-expand-sm border-bottom mb-3 px-2">
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#mainNav" aria-controls="mainNav" aria-expanded="false" aria-label="Přepnout navigaci">
              <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="mainNav">
              <ul class="navbar-nav me-auto gap-1">
                <li class="nav-item">
                  <router-link to="/order" class="nav-link" active-class="fw-semibold text-success">
                    <i class="bi bi-plus-circle me-1"></i>Nová objednávka
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link to="/order-history" class="nav-link" active-class="fw-semibold text-success">
                    <i class="bi bi-card-list me-1"></i>Historie objednávek
                  </router-link>
                </li>
                <li class="nav-item">
                  <a
                    href="https://www.girafruit.cz"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="nav-link"
                  >
                    <i class="bi bi-box-arrow-up-right me-1"></i>www.girafruit.cz
                  </a>
                </li>
              </ul>
              <div class="d-flex align-items-center gap-3 mt-2 mt-sm-0">
                <span class="text-muted small d-flex align-items-center gap-1">
                  <img v-if="appStore.user?.picture" :src="appStore.user.picture" class="rounded-circle" style="width:22px; height:22px; object-fit:cover;" alt="">
                  {{ appStore.user?.email }}
                </span>
                <button class="btn btn-sm btn-outline-danger" @click="appStore.logout">
                  <i class="bi bi-box-arrow-right me-1"></i>Odhlásit se
                </button>
              </div>
            </div>
          </nav>
          <main>
            <slot/>
          </main>
        </div>
        <div class="ovoce-pruh w-100"></div>
      </div>
    </div>
      <div class="paticka bg-primary text-center p-4 pb-5">

        <p class="">
          © {{ new Date().getFullYear()}} GIRA Jiří Bareš - GIRA fruit s.r.o. |
          <a href="https://www.haxo.cz"
                       class="text-white"
             target="_blank"
          title="Tvorba webových stránek, eshopů a aplikací na míru. SEO a PPC.">Tvorba
          webových stránek </a>
        </p>

      </div>
  </div>

</template>

<script>


import {useAppStore} from "@/stores/appStore";

export default {
  name: "default",
  components: {},
  data(){
    return {
      appStore: useAppStore(),
    }
  },
  methods:{}
}
</script>

<style scoped>

</style>
